var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialDistance = function SvgSocialDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 192C149.019 192 192 149.019 192 96C192 42.9807 149.019 0 96 0C42.9807 0 0 42.9807 0 96C0 149.019 42.9807 192 96 192Z",
    fill: "#23476C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 75.4492C81.5926 75.4492 70.2754 64.132 70.2754 50.2246C70.2754 36.3172 81.5926 25 95.5 25C109.407 25 120.725 36.3172 120.725 50.2246C120.725 64.132 109.407 75.4492 95.5 75.4492Z",
    fill: "#99B0C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.725 50.2246C120.725 36.3172 109.407 25 95.5 25V75.4492C109.407 75.4492 120.725 64.132 120.725 50.2246Z",
    fill: "#8599AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.154 81.1641L105.059 86.2597L108.662 89.8632H82.3377L85.9412 86.2597L80.8456 81.1641L68.543 93.4667L80.8456 105.769L85.9412 100.674L82.3377 97.0702H108.662L105.059 100.674L110.154 105.769L122.457 93.4667L110.154 81.1641Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8973 62.5272L82.1426 52.7722L87.2379 47.6769L91.8973 52.336L103.764 40.4698L108.859 45.5652L91.8973 62.5272Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 58.9237L108.858 45.5652L103.763 40.4698L95.5 48.7325V58.9237Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.154 105.769L122.457 93.4667L110.154 81.1641L105.059 86.2597L108.662 89.8632H95.5V97.0702H108.662L105.059 100.674L110.154 105.769Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0176 104.277C46.0564 104.277 41.207 99.428 41.207 93.4668C41.207 87.5056 46.0564 82.6562 52.0176 82.6562C57.9788 82.6562 62.8281 87.5056 62.8281 93.4668C62.8281 99.428 57.9788 104.277 52.0176 104.277Z",
    fill: "#D9E4EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0352 148H34V122.295C34 112.361 42.0798 104.277 52.0176 104.277C61.9554 104.277 70.0352 112.361 70.0352 122.295V148Z",
    fill: "#D9E4EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0352 148V122.295C70.0352 112.361 61.9554 104.277 52.0176 104.277V148H70.0352Z",
    fill: "#CBDAEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8281 93.4668C62.8281 87.5056 57.9788 82.6562 52.0176 82.6562V104.277C57.9788 104.277 62.8281 99.428 62.8281 93.4668Z",
    fill: "#CBDAEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.982 104.277C133.021 104.277 128.172 99.428 128.172 93.4668C128.172 87.5056 133.021 82.6562 138.982 82.6562C144.944 82.6562 149.793 87.5056 149.793 93.4668C149.793 99.428 144.944 104.277 138.982 104.277Z",
    fill: "#D9E4EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157 148H120.965V122.295C120.965 112.361 129.045 104.277 138.982 104.277C148.92 104.277 157 112.361 157 122.295V148Z",
    fill: "#D9E4EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157 148V122.295C157 112.361 148.92 104.277 138.982 104.277V148H157Z",
    fill: "#CBDAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.793 93.4668C149.793 87.5056 144.944 82.6562 138.982 82.6562V104.277C144.944 104.277 149.793 99.428 149.793 93.4668Z",
    fill: "#CBDAEA"
  })));
};
export default SvgSocialDistance;